import {
  AccessTokens,
  AccessTokenVariants,
  AllTokens,
  AnyAccess,
  ContextProtectionTokens,
  CurrentUserProtectionTokenFragment,
  EnabledTokens,
} from "gql/graphql";

/**
 * Код права любым из перечислений схемы. Значения у них общие — различаются только наборы
 * кодов, — но перечисления в TypeScript номинальны, и без объединения каждое место вызова
 * приводило бы тип к `AllTokens` вручную.
 */
export type ProtectionTokenCode =
  | AllTokens
  | AccessTokens
  | EnabledTokens
  | ContextProtectionTokens;

/**
 * Есть ли по праву доступ хоть к кому-нибудь — по снимку текущего пользователя.
 *
 * Это отдельный вопрос, а не уровень: у права с контекстами уровень зависит от того, чью запись
 * смотрят, и напротив конкретной записи может оказаться каким угодно. Ответ годится ровно на
 * одно решение — показывать ли связанный интерфейс там, где записи ещё нет: пункт меню, вход на
 * страницу, форма создания. «Что именно можно» спрашивают у самой записи.
 *
 * Право, которого в снимке нет, ничего не разрешает.
 */
export function hasAnyAccess(
  tokens: CurrentUserProtectionTokenFragment[],
  code: string,
) {
  const token = tokens.find((token) => {
    if (token.__typename === "AccessProtectionTokenDto") {
      return (token.accessToken as string) === code;
    }

    if (token.__typename === "EnabledProtectionTokenDto") {
      return (token.enabledToken as string) === code;
    }

    return (token.contextToken as string) === code;
  });

  if (token?.__typename === "AccessProtectionTokenDto") {
    return token.access !== AccessTokenVariants.None;
  }

  if (token?.__typename === "EnabledProtectionTokenDto") {
    return token.enabled;
  }

  if (token?.__typename === "ContextProtectionTokenDto") {
    return token.anyAccess !== AnyAccess.None;
  }

  return false;
}
